export default "__VITE_ASSET__c3bb6884__"